import MultiAdventurerModal from './MultiAdventurerModal';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { getAppScrollPos } from '../../../../store/selectors/app';
import get from 'lodash/get';

const enhance = compose(
  connect((state) => ({
    currentScrollPos: getAppScrollPos(state),
  })),
  withProps(props => {
    const fields = get(props, 'form.body', []);
    const multiAdventurerField = fields.find(field => field.sliceType === 'multi-adventurer') || {};
    const { arrowImage, activeModalButton } = multiAdventurerField.primary;
    const buttonTheme = {
      colour: props.isModalOpen ? 'grey-light' : 'green',
      raised: !props.isModalOpen,
      outlined: props.isModalOpen,
    };
    return {
      cta: props.isModalOpen ? activeModalButton : props.form.cta,
      buttonTheme,
      arrowImage,
    };
  })
);

export default enhance(MultiAdventurerModal);
